module.exports = __webpack_public_path__ + "img/card-frecuente-web@3x.fb35143f.png";